// @flow
import { CONDITION_ITEMS } from './constants/conditions'
import { ConditionName, Option, PeriodParams } from './actions'
import format from 'date-fns/format'
import _ from 'lodash'
import {
  SourcingRouteId,
  StatusConditionItem,
  StatusConditionState,
} from './reducers/condition'
import { StatusesState } from './reducers/statuses'
import { ContactPersonsFilterListState } from './reducers/contactPersonsFilterList'
import { SourcingRoute } from './reducers/sourcingAnnotationCandidates'

export const unique = (array: any[]) =>
  array.filter((v, i, self) => self.indexOf(v) === i)

export function formatNumber(v?: number | null): string | undefined {
  if (v === null || typeof v === 'undefined') {
    return
  }
  return v.toLocaleString()
}

export function formatRange(
  v: { start: number; end: number | null } | null
): string | undefined {
  if (v == null || v.start == null) {
    return
  }

  return `${v.start.toLocaleString()}-${
    v.end != null ? v.end.toLocaleString() : ''
  }`
}

export function formatDatetime(v?: string | null): string | undefined {
  if (v === null || typeof v === 'undefined') {
    return
  }
  return v.substring(0, 10)
}

export function formatCondition(
  name: ConditionName,
  selected: Option[] | string[]
): string | undefined {
  const options = CONDITION_ITEMS[name].options
  let label = CONDITION_ITEMS[name].label
  if (0 < selected.length) {
    if (!options[selected[0]]) {
      return label
    }
    let caption = options[selected[0]].label
    if (1 < selected.length) {
      caption += ', ...'
    }
    label += ` = ${caption}`
  }
  return label
}

export function cutDigit(n?: number): number | undefined {
  if (
    n === undefined ||
    n === null ||
    (!Number.isNaN(n) && !Number.isInteger(n))
  ) {
    return
  }
  const s = n.toString()
  return parseInt(s.substring(0, s.length - 3))
}

export function formatPeriodCondition(s: string, period: PeriodParams): string {
  const { from, to } = period
  const label = from ? `${from} ≦ ${s}` : s
  return to ? `${label} ≦ ${to}` : label
}

export function timestamp(): string {
  return format(new Date(), 'yyyyMMdd_HHmm')
}

export function fromEntries(iterable: any) {
  return [...iterable].reduce(
    (obj, { 0: key, 1: val }) => Object.assign(obj, { [key]: val }),
    {}
  )
}

export function formatConditionSourcingRouteDisplay(
  sourcingRoutes: SourcingRoute[],
  selectedSourcingRouteIds: SourcingRouteId[]
) {
  var s = ''
  if (selectedSourcingRouteIds.length >= 1) {
    s += ` = ${
      sourcingRoutes.find((s) => s.id === selectedSourcingRouteIds[0].id)?.name
    }`
  }
  if (selectedSourcingRouteIds.length > 1) {
    s += ', ...'
  }
  return s
}

export function formatConditionDisplay<
  B extends (
    | ContactPersonsFilterListState['data'][0]
    | StatusesState['data'][0]
  )[],
>(
  filterItems: StatusConditionState['filterItems'],
  statusConditionItems: StatusConditionItem,
  contactPersons: B,
  fn: (arg: B[0]) => string
): string {
  if (
    filterItems.filter((i) => i.itemName === statusConditionItems).length > 0
  ) {
    const selectedFilterList = _.flatten(
      _.flatten(
        filterItems
          .filter((i) => i.itemName === statusConditionItems)
          .map((i) =>
            i.conditions.map((c) =>
              contactPersons
                .filter((cp) => cp.id.toString() === c.id.toString())
                .map(fn)
            )
          )
      )
    )

    return ` = ${
      selectedFilterList.length > 1
        ? `${selectedFilterList[0]}, ...`
        : selectedFilterList[0]
    }`
  }

  return ''
}
